import React from 'react'
import { Link } from 'gatsby'
import Slider from 'react-slick'
import Img from 'gatsby-image'
import { FiChevronRight, FiChevronLeft } from 'react-icons/fi'
import Container from './styles'

function NextArrow(props) {
  const { onClick } = props
  return (
    <div className="arrow next" onClick={onClick} role="none">
      <FiChevronRight size="1.5em" />
    </div>
  )
}
function PrevArrow(props) {
  const { onClick } = props
  return (
    <div className="arrow prev" onClick={onClick} role="none">
      <FiChevronLeft size="1.5em" />
    </div>
  )
}

const NossosServicos = ({ servicos }) => {
  let settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: false,
        },
      },
      {
        breakpoint: 666,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  }
  return (
    <Container>
      <h3>Nossos serviços</h3>
      <div className="servicos">
        <div className="description-text">
          <strong>
            A nossa maternidade oferece diversos serviços, como UTI adulto
            especializada, UTI neonatal referência em todo o país e ainda conta
            uma equipe multidisciplinar altamente qualificada para garantir a
            saúde e o bem-estar de seus pacientes.
          </strong>
        </div>
        <div className="sliderContainer">
          <Slider {...settings}>
            {servicos.map(servico => (
              <Link to={servico.link} key={servico.id}>
                <h4>{servico.title}</h4>
                {servico.featuredImage.node.localFile ? (
                  <Img
                    fluid={
                      servico.featuredImage.node.localFile.childImageSharp.fluid
                    }
                    alt=""
                  />
                ) : (
                  <img src={servico.featuredImage.node.sourceUrl} alt="" />
                )}
                <div dangerouslySetInnerHTML={{ __html: servico.excerpt }} />
              </Link>
            ))}
          </Slider>
        </div>
      </div>
    </Container>
  )
}
export default NossosServicos
